import { TradeAreaIcon } from 'src/components/insights/icons/trade-area'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import dynamic from 'next/dynamic'
import preview from 'src/assets/images/widgets-previews/tta-visitor-origin.png'

const VisitorOrigin = dynamic(() => import('src/components/insights/true-trade-area/visitor-origin'), { ssr: false })

export const VisitorOriginWidget: InsightBuilderWidget = {
  id: 'true-trade-area-visitor-origin',
  name: 'True Trade Area: Visitor Origin',
  type: 'True Trade Area',
  icon: TradeAreaIcon,
  component: VisitorOrigin,
  supportedResultTypes: ['alphamap-location'],
  preview,
}
